// 本地储存
export const local = {
  get: (key) => {
    let value = localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  },
  set: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  del: (key) => {
    localStorage.removeItem(key);
  }
}

// session储存
export const session = {
  get: (key) => {
    let value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  },
  set: (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  del: (key) => {
    sessionStorage.removeItem(key);
  }
}